<script>
import Website from '@wielink-application/shared/vue/components/form/input-only/website.vue'

export default Website;
</script>